import { useEffect } from 'react';

const InstagramFeed = () => {
  useEffect(() => {
    const script = document.createElement('script');
    script.src = "https://apps.elfsight.com/p/platform.js";
    script.defer = true;
    document.body.appendChild(script);
  }, []);

  return (
    <div className="elfsight-app-0ff4bdd4-45f0-424f-8d07-e981c42d88d0" style={{margin:'0 auto'}} data-elfsight-app-lazy></div>
  );
};

export default InstagramFeed;
